import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Table, Modal } from "react-bootstrap";
import Layout from "../../layout/Layout";
import "../../styles/StandardDocument.css";
import { useAuth } from "../../context/AuthContext";

import {
  getSignedUrl,
  getAllSharedDocuments,
} from "../../../api/DocumentApi/getGeneralApi";

function SharedDocumentAll() {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all"); // default all
  const [feedback, setFeedback] = useState({
    show: false,
    type: "success",
    message: "",
  });
  const [docs, setDocs] = useState([]);

  const fetchDocs = async (cat = "all") => {
    try {
      const res = await getAllSharedDocuments(cat);
      if (res.data.statusCode === 200) {
        setDocs(res.data.data);
      }
    } catch (err) {
      console.error("Belgeler çekilemedi:", err);
    }
  };

useEffect(() => {
  fetchDocs(category);
}, [category]);


  // kategori değişince
  const handleCategoryChange = (e) => {
    const newCat = e.target.value || "all";
    setCategory(newCat);
    fetchDocs(newCat);
  };

  // search filtre
  const filteredDocs = docs.filter(
    (d) =>
      d.title.toLowerCase().includes(search.toLowerCase()) ||
      d.description?.toLowerCase().includes(search.toLowerCase())
  );

  const handleOpenDocument = async (type, id) => {
    try {
      const res = await getSignedUrl(type, id);
      if (res.data.url) {
        window.open(res.data.url, "_blank");
      }
    } catch (err) {
      console.error("Signed URL alınamadı:", err);
    }
  };

  const CATEGORY_LABELS = {
    planlama: "Planlama",
    kalite: "Kalite",
    satis: "Satış",
    muhasebe: "Muhasebe",
    insanKaynaklari: "İnsan Kaynakları",
    uretim: "Üretim",
    disTicaret: "Dış Ticaret",
    bakim: "Bakım",
    satinalma: "Satın Alma",
    isg: "İSG"
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Departmanlar Arası Ortak Dokümanlar</h2>
      <Card className="p-3 mb-4 shadow-sm border-0">
        <Row className="align-items-center g-3">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Select value={category} onChange={handleCategoryChange}>
              <option value="all">Tüm Kategoriler</option>
              {Object.entries(CATEGORY_LABELS).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm border-0">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th>Kategori</th>
              <th>Başlık</th>
              <th>Açıklama</th>
              <th>Yükleyen</th>
              <th>Döküman</th>
              <th>Hatırlatıcı Durumu</th>
              <th>Kalan Süre</th>
              <th>Durum Noktası</th>
              <th>Yüklenme Tarihi</th>
            </tr>
          </thead>
          <tbody>
            {filteredDocs.length > 0 ? (
              filteredDocs.map((d) => {
                let statusText = "Pasif";
                let dotColor = "gray";
                let daysText = "—";
                let dotBlink = false;

                if (d.reminder) {
                  const daysLeft = d.reminder.daysLeft;
                  const notifyBefore = d.reminder.notifyBefore;

                  if (daysLeft <= 0) {
                    statusText = "Süre Doldu!";
                    dotColor = "red";
                    daysText = "Süre bitti";
                    dotBlink = true;
                  } else if (daysLeft <= notifyBefore) {
                    statusText = "Yaklaşıyor";
                    dotColor = "orange";
                    daysText = `${daysLeft} gün kaldı`;
                    dotBlink = true;
                  } else {
                    statusText = "Aktif";
                    dotColor = "green";
                    daysText = `${daysLeft} gün kaldı`;
                  }
                }

                return (
                  <tr key={d._id}>
                    <td>{CATEGORY_LABELS[d.category] || d.category}</td>
                    <td>{d.title}</td>
                    <td>{d.description}</td>
                    <td>
                      {d.personelId
                        ? `${d.personelId.name || ""} ${
                            d.personelId.surname || ""
                          }`.trim()
                        : "Bulunamadı"}
                    </td>
                    <td>
                      <Button
                        variant="link"
                        onClick={() => handleOpenDocument("shared", d._id)}
                      >
                        Görüntüle
                      </Button>
                    </td>
                    <td>{statusText}</td>
                    <td>{daysText}</td>
                    <td>
                      <span
                        className={`dot ${dotBlink ? "blink" : ""}`}
                        style={{ backgroundColor: dotColor }}
                      ></span>
                    </td>
                    <td>{new Date(d.createdAt).toLocaleDateString("tr-TR")}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={
                    user?.permissions.includes("kalite_shared_update")
                      ? "10"
                      : "9"
                  }
                  className="text-center text-muted py-4"
                >
                  Kayıt bulunamadı
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>

      {/* Feedback Modal */}
      <Modal
        show={feedback.show}
        onHide={() => setFeedback({ ...feedback, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {feedback.type === "success" ? "Başarılı" : "Hata"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{feedback.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setFeedback({ ...feedback, show: false })}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default SharedDocumentAll;
